<template>
  <div>
    <div class="breadcrumb-box" style="padding: 1rem 1.875rem 1rem 1rem">
      <div class="breadcrumb">
        <span class="first" @click="back">测评设置</span>
        /
        <span class="last">编辑规则</span>
      </div>
    </div>
    <div class="system-setting">
      <el-card style="margin: 0 1rem">
        <p slot="header">系统监测自动扣分</p>
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          label-width="6.875rem"
          class="demo-ruleForm"
          :hide-required-asterisk="true"
          size="small"
        >
          <el-form-item label="考核内容："> 是否超额投放 </el-form-item>
          <el-form-item
            label="扣分："
            prop="exceedDeductRule"
            style="display: inline-block"
          >
            <el-input
              v-model="form.exceedDeductRule"
              placeholder="请填写"
              style="width: 5rem"
            >
            </el-input>
            分/辆
          </el-form-item>
          <el-form-item
            label="扣分上限："
            prop="exceedScoreLimit"
            style="display: inline-block"
            label-width="6.125rem"
          >
            <el-input
              v-model="form.exceedScoreLimit"
              placeholder="请填写"
              style="width: 5rem"
            >
            </el-input>
            分
          </el-form-item>
          <el-form-item label="是否纳入考核：" prop="exceedAssessSwitch">
            <el-switch
              size="mini"
              v-model="form.exceedAssessSwitch"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0"
              @change="changeSwitch(1)"
            >
            </el-switch>
          </el-form-item>
          <el-form-item
            label="触发退市："
            prop="exceedQuitSwitch"
            style="display: inline-block"
          >
            <el-switch
              size="mini"
              :disabled="!form.exceedAssessSwitch"
              v-model="form.exceedQuitSwitch"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </el-form-item>
          <el-form-item
            prop="exceedQuitRule"
            style="display: inline-block"
            label="周期内超过"
            label-width="6.125rem"
          >
            <el-input
              :disabled="!form.exceedQuitSwitch"
              v-model="form.exceedQuitRule"
              placeholder="请填写"
              style="width: 5rem"
            >
            </el-input>
            辆
          </el-form-item>
          <el-form-item label="考核描述：" prop="exceedDescribe">
            <el-input
              type="textarea"
              v-model="form.exceedDescribe"
              maxlength="500"
              placeholder="请填写"
              style="width: 80%"
            >
            </el-input>
          </el-form-item>
          <div
            class="el-card__header"
            style="margin-bottom: 1.5rem; padding: 1.125rem 0 0 0"
          >
            <span>系统监测通知单车企业整改系统自动核查</span>
          </div>
          <el-form-item label="考核内容："> 处置及时率 </el-form-item>
          <el-form-item label="指令设置：" style="margin-bottom: 0">
            <el-form-item
              prop="dispatchOutsideTimeout"
              style="display: inline-block">
              <span style="color: red">站外还车响应时间</span>
              <el-input
                v-model="form.dispatchOutsideTimeout"
                placeholder="请填写"
                style="width: 5rem;margin-left: 0.3125rem"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              prop="dispatchOutsideRule"
              style="display: inline-block"
            >
              分钟，未及时处置扣
              <el-input
                v-model="form.dispatchOutsideRule"
                placeholder="请填写"
                style="width: 5rem"
              >
              </el-input>
              分/辆
            </el-form-item>
            <el-form-item
              label="扣分上限："
              prop="outsideScoreLimit"
              style="display: inline-block"
              label-width="6.125rem"
            >
              <el-input
                v-model="form.outsideScoreLimit"
                placeholder="请填写"
                style="width: 5rem"
              >
              </el-input>
              分
            </el-form-item>
            <br />
            <el-form-item
              label="启用自动化考核："
              prop="enable"
              style="display: inline-block"
              label-width="8.125rem"
            >
              <el-switch
                size="mini"
                v-model="form.enable"
                @change="changeSwitch(2)"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <el-form-item
              label="自动化考核异常终止："
              prop="abortTerminateSwitch"
              style="display: inline-block"
              label-width="10rem"
            >
              <el-switch
                size="mini"
                :disabled='!form.enable'
                v-model="form.abortTerminateSwitch"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <br/>
            <el-form-item
              label="是否纳入考核："
              prop="dispatchAssessSwitch"
              style="display: inline-block"
              label-width="8.125rem">
              <el-switch
                size="mini"
                v-model="form.dispatchAssessSwitch"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item
              label="不合格："
              prop="dispatchPassSwitch"
              style="display: inline-block" label-width="4.6875rem">
              <el-switch
                size="mini"
                v-model="form.dispatchPassSwitch"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item
              style="display: inline-block"
              label="周期内超过"
              :disabled="!form.dispatchPassSwitch"
              label-width="6.125rem">
              <el-input
                v-model="form.dispatchPassRule"
                placeholder="请填写"
                style="width: 5rem">
              </el-input>
              分
            </el-form-item>
            <el-form-item label="考核描述：" prop="outsideDescribe">
              <el-input
                type="textarea"
                v-model="form.outsideDescribe"
                maxlength="500"
                placeholder="请填写"
                style="width: 80%"
              >
              </el-input>
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item
              prop="dispatchLegalityTimeout"
              style="display: inline-block">
              <span style="color: red"> 非法车辆响应时间</span>
              <el-input
                v-model="form.dispatchLegalityTimeout"
                placeholder="请填写"
                style="width: 5rem;margin-left: 0.3125rem"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              prop="dispatchLegalityRule"
              style="display: inline-block"
            >
              分钟，未及时处置扣
              <el-input
                v-model="form.dispatchLegalityRule"
                placeholder="请填写"
                style="width: 5rem"
              >
              </el-input>
              分/辆
            </el-form-item>
            <el-form-item
              label="扣分上限："
              prop="legalityScoreLimit"
              style="display: inline-block"
              label-width="6.125rem"
            >
              <el-input
                v-model="form.legalityScoreLimit"
                placeholder="请填写"
                style="width: 5rem"
              >
              </el-input>
              分
            </el-form-item>
            <br/>
            <el-form-item
              label="启用自动化考核："
              prop="legalityEnable"
              style="display: inline-block"
              label-width="8.125rem"
            >
              <el-switch
                size="mini"
                v-model="form.legalityEnable"
                @change="changeSwitch(2)"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <el-form-item
              label="自动化考核异常终止："
              prop="legalityAbortTerminate"
              style="display: inline-block"
              label-width="10rem"
            >
              <el-switch
                size="mini"
                :disabled='!form.legalityEnable'
                v-model="form.legalityAbortTerminate"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <br/>
            <el-form-item
              label="是否纳入考核："
              prop="legalityDispatchAssess"
              style="display: inline-block"
              label-width="8.125rem">
              <el-switch
                size="mini"
                v-model="form.legalityDispatchAssess"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item
              label="不合格："
              prop="legalityDispatchPass"
              style="display: inline-block" label-width="4.6875rem">
              <el-switch
                size="mini"
                v-model="form.legalityDispatchPass"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item
              style="display: inline-block"
              label="周期内超过"
              :disabled="!form.legalityDispatchPass"
              label-width="6.125rem">
              <el-input
                v-model="form.legalityPassRule"
                placeholder="请填写"
                style="width: 5rem">
              </el-input>
              分
            </el-form-item>
            <el-form-item label="考核描述：" prop="legalityDescribe">
              <el-input
                type="textarea"
                v-model="form.legalityDescribe"
                maxlength="500"
                placeholder="请填写"
                style="width: 80%"
              >
              </el-input>
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item prop="importantMuchArea" style="display: inline-block;">
              <span style="color: red">重点偏多区域</span>
              <el-input
                v-model="form.importantMuchArea"
                placeholder="请填写"
                style="width: 5rem;margin-left: 0.3125rem"
              >
              </el-input>
              分/件
            </el-form-item>
            <el-form-item
              label="扣分上限："
              prop="importantScoreLimit"
              style="display: inline-block"
              label-width="6.125rem"
            >
              <el-input
                v-model="form.importantScoreLimit"
                placeholder="请填写"
                style="width: 5rem"
              >
              </el-input>
              分
            </el-form-item>
            <br/>
            <el-form-item
              label="启用自动化考核："
              prop="importantEnable"
              style="display: inline-block"
              label-width="8.125rem"
            >
              <el-switch
                size="mini"
                v-model="form.importantEnable"
                @change="changeSwitch(2)"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <el-form-item
              label="自动化考核异常终止："
              prop="importantAbortTerminate"
              style="display: inline-block"
              label-width="10rem"
            >
              <el-switch
                size="mini"
                :disabled='!form.importantEnable'
                v-model="form.importantAbortTerminate"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <br/>
            <el-form-item
              label="是否纳入考核："
              prop="importantDispatchAssess"
              style="display: inline-block"
              label-width="8.125rem">
              <el-switch
                size="mini"
                v-model="form.importantDispatchAssess"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item
              label="不合格："
              prop="importantDispatchPass"
              style="display: inline-block" label-width="4.6875rem">
              <el-switch
                size="mini"
                v-model="form.importantDispatchPass"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item
              style="display: inline-block"
              label="周期内超过"
              :disabled="!form.importantDispatchPass"
              label-width="6.125rem">
              <el-input
                v-model="form.importantPassRule"
                placeholder="请填写"
                style="width: 5rem">
              </el-input>
              分
            </el-form-item>
            <el-form-item label="考核描述：" prop="importantDescribe" style="left: 50px">
              <el-input
                type="textarea"
                v-model="form.importantDescribe"
                maxlength="500"
                placeholder="请填写"
                style="width: 80%"
              >
              </el-input>
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item prop="commonMuchArea" style="display: inline-block">
              <span style="color: red">普通偏多区域</span>
              <el-input
                v-model="form.commonMuchArea"
                placeholder="请填写"
                style="width: 5rem;margin-left: 0.3125rem"
              >
              </el-input>
              分/件
            </el-form-item>
            <el-form-item
              label="扣分上限："
              prop="commonScoreLimit"
              style="display: inline-block"
              label-width="6.125rem"
            >
              <el-input
                v-model="form.commonScoreLimit"
                placeholder="请填写"
                style="width: 5rem"
              >
              </el-input>
              分
            </el-form-item>
            <br/>
            <el-form-item
              label="启用自动化考核："
              prop="commonEnable"
              style="display: inline-block"
              label-width="8.125rem"
            >
              <el-switch
                size="mini"
                v-model="form.commonEnable"
                @change="changeSwitch(2)"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <el-form-item
              label="自动化考核异常终止："
              prop="commonAbortTerminate"
              style="display: inline-block"
              label-width="10rem"
            >
              <el-switch
                size="mini"
                :disabled='!form.commonEnable'
                v-model="form.commonAbortTerminate"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <br/>
            <el-form-item
              label="是否纳入考核："
              prop="commonDispatchAssess"
              style="display: inline-block"
              label-width="8.125rem">
              <el-switch
                size="mini"
                v-model="form.commonDispatchAssess"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item
              label="不合格："
              prop="commonDispatchPass"
              style="display: inline-block" label-width="4.6875rem">
              <el-switch
                size="mini"
                v-model="form.commonDispatchPass"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
            <el-form-item
              style="display: inline-block"
              label="周期内超过"
              :disabled="!form.commonDispatchPass"
              label-width="6.125rem">
              <el-input
                v-model="form.commonPassRule"
                placeholder="请填写"
                style="width: 5rem">
              </el-input>
              分
            </el-form-item>
            <el-form-item label="考核描述：" prop="dispatchDescribe">
              <el-input
                type="textarea"
                v-model="form.dispatchDescribe"
                maxlength="500"
                placeholder="请填写"
                style="width: 80%"
              >
              </el-input>
            </el-form-item>
          </el-form-item>
          <div class="border" style="margin-bottom: 2rem"></div>
          <el-form-item label="考核内容："> 处置完结情况 </el-form-item>
          <el-form-item
            label="完结率低于"
            prop="finishRate"
            style="display: inline-block"
          >
            <el-input
              v-model="form.finishRate"
              placeholder="请填写"
              style="width: 5rem"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            prop="finishScore"
            style="display: inline-block"
            label="%，扣分："
            label-width="5.3125rem"
          >
            <el-input
              v-model="form.finishScore"
              placeholder="请填写"
              style="width: 5rem"
            >
            </el-input>
            分
          </el-form-item>
          <el-form-item
            label="扣分上限："
            prop="finishScoreLimit"
            style="display: inline-block"
            label-width="6.125rem"
          >
            <el-input
              v-model="form.finishScoreLimit"
              placeholder="请填写"
              style="width: 5rem"
            >
            </el-input>
            分
          </el-form-item>
          <el-form-item label="是否纳入考核：" prop="finishAssessSwitch">
            <el-switch
              size="mini"
              v-model="form.finishAssessSwitch"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="考核描述：" prop="finishDescribe">
            <el-input
              type="textarea"
              v-model="form.finishDescribe"
              maxlength="500"
              placeholder="请填写"
              style="width: 80%"
            >
            </el-input>
          </el-form-item>
          <div style="text-align: center">
            <el-button
              :loading="loading"
              @click="onEditSure"
              type="primary"
              size="small"
              >保存</el-button
            >
          </div>
        </el-form>
      </el-card>
      <el-card style="margin: 1rem">
        <p slot="header">违规上报通知单车企业整改人工核查</p>
        <span class="addbtn" @click="onShowDialog(1)">
          <i class="el-icon-circle-plus"></i> 创建考核内容
        </span>
        <w-table
          :data-list="rule1"
          :columns="staticData.assessment"
          :bPagination="false"
        >
          <template slot-scope="{ text, row }" slot="koufen">
            <span>{{ text + "分/" + row.unit }}</span>
          </template>
          <template slot-scope="{ text }" slot="category">
            <span>{{ getcategoryName(text) }}</span>
          </template>
          <template slot-scope="{ text }" slot="xiangying">
            <span>{{ text + "分钟" }}</span>
          </template>
          <template slot-scope="{ row }" slot="yingyong">
            <el-switch
              v-model="row.enable"
              :active-value="1"
              :inactive-value="0"
              @change="changeRule($event, row.id)"
            ></el-switch>
          </template>
          <template slot-scope="{ text }" slot="isin">
            {{ text ? "是" : "否" }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-button type="text" @click="del(row)">删除</el-button>
            <i class="el-icon-top" @click="moveUp(row,rule1,1)"></i>
            <i class="el-icon-bottom" @click="moveDown(row,rule1,1)"></i>
          </template>
          <template slot-scope="{ text }" slot="cell">
            <span>{{ text }}</span>
          </template>
        </w-table>
      </el-card>
      <el-card style="margin: 1rem">
        <p slot="header">人工直接扣分</p>
        <span class="addbtn" @click="onShowDialog(2)">
          <i class="el-icon-circle-plus"></i> 创建考核内容
        </span>
        <w-table
          :data-list="rule2"
          :columns="staticData.autoDown"
          :bPagination="false"
        >
          <template slot-scope="{ text, row }" slot="koufen">
            <span>{{ text + "分/" + row.unit }}</span>
          </template>
          <template slot-scope="{ text }" slot="category">
            <span>{{ getcategoryName(text) }}</span>
          </template>
          <template slot-scope="{ text }" slot="xiangying">
            <span>{{ text + "分钟" }}</span>
          </template>
          <template slot-scope="{ row }" slot="yingyong">
            <el-switch
              v-model="row.enable"
              :active-value="1"
              :inactive-value="0"
              @change="changeRule($event, row.id)"
            ></el-switch>
          </template>
          <template slot-scope="{ text }" slot="isin">
            {{ text ? "是" : "否" }}
          </template>
          <template slot-scope="{ text, row }" slot="qualified">
            {{ text ? `是,周期内超过${row.qualifiedScore}分` : "否" }}
          </template>
          <template slot-scope="{ text, row }" slot="delist">
            {{ text ? `开,周期内超过${row.delistScore}分` : "关" }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-button type="text" @click="del(row)">删除</el-button>
            <i class="el-icon-top" @click="moveUp(row,rule2,2)"></i>
            <i class="el-icon-bottom" @click="moveDown(row,rule2,2)"></i>
          </template>
          <template slot-scope="{ text }" slot="cell">
            <span>{{ text }}</span>
          </template>
        </w-table>
      </el-card>
    </div>
    <w-dialog
      ref="w-dialog"
      title="创建考核内容"
      width="37.5rem"
      sureBtnText="保存"
      @handleClose="handleClose"
      @handleCloseRight="handleClose"
      @onSure="onSure"
    >
      <template v-slot:content>
        <el-form
          :model="form2"
          :rules="rules"
          :hide-required-asterisk="true"
          ref="ruleForm2"
          label-width="6.875rem"
          class="dialog-content"
          size="small"
        >
          <el-form-item label="考核内容：" prop="title">
            <el-input
              v-model="form2.title"
              placeholder="请填写"
              style="width: 80%"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="分类：" prop="categoryId">
            <el-cascader
              :show-all-levels="false"
              v-model="form2.categoryId"
              placeholder="请填写"
              :options="category"
              :props="{
                emitPath: false,
                children: 'child',
                label: 'title',
                value: 'id',
              }"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="响应时间：" prop="reTime" v-if="form2.type == 1">
            <el-input
              v-model="form2.reTime"
              placeholder="请填写"
              style="width: 5rem"
            >
            </el-input>
            分钟
          </el-form-item>
          <el-form-item
            label="扣分："
            prop="score"
            style="display: inline-block"
          >
            <el-input
              v-model="form2.score"
              placeholder="请填写"
              style="width: 5rem"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            prop="unit"
            style="display: inline-block"
            label="分/"
            label-width="2.125rem"
          >
            <el-input
              v-model="form2.unit"
              placeholder="单位"
              style="width: 5rem"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            label="扣分上限："
            prop="scoreLimit"
            style="display: inline-block"
            label-width="6.125rem">
            <el-input
              v-model="form.scoreLimit"
              placeholder="请填写"
              style="width: 5rem">
            </el-input>
            分
          </el-form-item>
          <el-form-item label="是否纳入考核：" prop="isIn">
            <el-switch
              size="mini"
              v-model="form2.isIn"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </el-form-item>
          <template v-if="form2.type == 2">
            <el-form-item
              label="不合格："
              prop="qualified"
              style="display: inline-block"
            >
              <el-switch
                size="mini"
                v-model="form2.qualified"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <el-form-item
              style="display: inline-block"
              label="周期内超过"
              label-width="5.875rem"
            >
              <el-input
                v-model="form2.qualifiedScore"
                placeholder="请填写"
                style="width: 5rem"
              >
              </el-input>
              分
            </el-form-item>

            <el-form-item
              label="触发退市："
              prop="delist"
              style="display: inline-block"
            >
              <el-switch
                size="mini"
                v-model="form2.delist"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </el-form-item>
            <el-form-item
              style="display: inline-block"
              label="周期内超过"
              label-width="5.875rem"
            >
              <el-input
                v-model="form2.delistScore"
                placeholder="请填写"
                style="width: 5rem"
              >
              </el-input>
              分
            </el-form-item>
          </template>
          <el-form-item label="考核描述：" prop="description">
            <el-input
              type="textarea"
              v-model="form2.description"
              maxlength="500"
              placeholder="请填写"
              style="width: 80%"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            label="启用考核："
            prop="enable"
            style="display: inline-block"
            label-width="8.125rem"
          >
            <el-switch
              size="mini"
              v-model="form2.enable"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import staticData from '../staticData.js'
import WTable from '@/components/Table/index.vue'
import WDialog from '@/components/Model/index.vue'
import { mapGetters } from 'vuex'
import Api from '@/api'
export default {
  data() {
    const validateExceedQuitRule = (rule, value, callback) => {
      // 如果开关未开启 (即 form.exceedQuitSwitch 不为 1)，则直接通过校验(不需要校验)
      if (!this.form.exceedQuitSwitch) {
        callback()
      } else {
        // 如果开关开启，则检查是否填写了值
        if (value === '' || value === undefined || value === null) {
          callback(new Error('请输入退市条件'))
        } else {
          // 可以在这里添加额外的数字校验，例如必须是正整数
          if (!Number.isInteger(Number(value)) || Number(value) <= 0) {
            callback(new Error('请输入有效的正整数'))
          } else {
            callback()
          }
        }
      }
    }
    return {
      rule1: [],
      rule2: [],
      staticData,
      loading: false,
      form: {},
      form2: {},
      // 合并 staticData 的规则并覆盖 exceedQuitRule
      rules: {
        ...staticData.rule,
        exceedQuitRule: [
          { validator: validateExceedQuitRule, trigger: 'blur' }
        ]
      },
      category: []
    }
  },
  components: {
    WTable,
    WDialog
  },
  computed: {
    ...mapGetters(['selfAreaId'])
  },
  created() {
    Api.getCategory({ selfAreaId: this.selfAreaId }).then(({ data }) => {
      this.category = data
    })
  },
  mounted() {
    this.getFixedRule()
    this.getTrendsRule(0)
    // this.getTrendsRule(2)
  },
  methods: {
    changeRule(val, id) {
      Api.setTrendsRuleEnable(this.selfAreaId, { id, enable: val }).then(
        ({ data }) => {
          console.log(data)
        }
      )
    },
    getcategoryName(id) {
      const arr = this.category.map((val) => {
        return [val, ...val.child]
      })
      const value = arr.flat().find((val) => {
        return val.id == id
      })
      return value ? value.title : ''
    },
    getFixedRule() {
      Api.getFixedRule(this.selfAreaId).then(({ data }) => {
        this.form = data
      })
    },
    getTrendsRule(type) {
      Api.getTrendsRule({ selfAreaId: this.selfAreaId, type: type }).then(
        ({ data }) => {
          if (type == 1 || type == 0) {
            this.rule1 = data.filter((val) => {
              return val.type == 1
            })
          }
          if (type == 2 || type == 0) {
            this.rule2 = data.filter((val) => {
              return val.type == 2
            })
          }
        }
      )
    },
    back() {
      this.$refs.ruleForm.resetFields()
      this.$emit('back')
    },
    handleClose() {
      this.$refs['w-dialog'].onCloseDialog()
      this.$refs.ruleForm2.resetFields()
      this.$set(this, 'form2', {})
    },
    onSure() {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          Api.saveTrendsRule(this.selfAreaId, this.form2).then((data) => {
            this.$message.success('编辑成功')
            this.getTrendsRule(this.form2.type)
            this.handleClose()
          })
        } else {
          return false
        }
      })
    },
    changeSwitch(type) {
      if (type == 1 && !this.form.exceedAssessSwitch) {
        this.form.exceedQuitSwitch = 0
      }
      if (type == 2 && !this.form.enable) {
        this.form.abortTerminateSwitch = 0
      }
    },
    edit(data) {
      this.$set(this, 'form2', { ...data })
      this.$refs['w-dialog'].onShowDialog()
    },
    // 删除人工直接扣分内容
    del(row) {
      this.$confirm('确定删除分类【' + row.categoryName + '】', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          Api.delExamine(row.id, this.selfAreaId).then((res) => {
              if (res.code === 200) {
                // 删除成功
                this.$message.success('删除成功')
                this.getTrendsRule(0)
              } else {
                this.$message.warning(res && res.message)
              }
            }).catch((e) => {
              console.log(e)
            })
        }).catch(() => {})
    },
    // 考核分类内容上移
    moveUp(row, data, type) {
      // 获取当前选中行的索引
      const selectedIndex = data.indexOf(row)
      // 如果当前选中行不是第一行，执行上移操作
      if (selectedIndex > 0) {
        // 交换当前行和上一行的排序值
        this.swapSortOrder(selectedIndex, selectedIndex - 1, data, type)
        // 更新数据库中的排序字段
        console.log(data[selectedIndex])
        this.updateSortOrderInDatabase(data[selectedIndex].id, data[selectedIndex].sort, data[selectedIndex])
        this.updateSortOrderInDatabase(data[selectedIndex - 1].id, data[selectedIndex - 1].sort, data[selectedIndex - 1])
        // 在前端更新数据数组
        if (type === 1) {
          this.rule1.splice(selectedIndex - 1, 2, data[selectedIndex], data[selectedIndex - 1])
        } else {
          this.rule2.splice(selectedIndex - 1, 2, data[selectedIndex], data[selectedIndex - 1])
        }
      } else {
        this.$message.warning('上移是第一行，无法上移')
      }
    },
    // 考核分类内容下移
    moveDown(row, data, type) {
      // 找到当前选中行的索引
      const selectedIndex = data.indexOf(row)
      // 如果当前选中行不是最后一行，执行下移操作
      if (selectedIndex < data.length - 1) {
        // 交换当前行和下一行的排序值
        this.swapSortOrder(selectedIndex, selectedIndex + 1, data, type)
        // 更新数据库中的排序字段
        this.updateSortOrderInDatabase(data[selectedIndex].id, data[selectedIndex].sort, data[selectedIndex])
        this.updateSortOrderInDatabase(data[selectedIndex + 1].id, data[selectedIndex + 1].sort, data[selectedIndex + 1])
        // 在前端更新数据数组
        if (type === 1) {
          this.rule1.splice(selectedIndex, 2, data[selectedIndex + 1], data[selectedIndex])
        } else {
          this.rule2.splice(selectedIndex, 2, data[selectedIndex + 1], data[selectedIndex])
        }
      } else {
        this.$message.warning('下移是最后一行，无法下移')
      }
    },
    swapSortOrder(index1, index2, data, type) {
      const tempSortOrder = data[index1].sort
      if (type === 1) {
        this.rule1[index1].sort = data[index2].sort
        this.rule1[index2].sort = tempSortOrder
      } else {
        this.rule2[index1].sort = data[index2].sort
        this.rule2[index2].sort = tempSortOrder
      }
    },
    updateSortOrderInDatabase(id, newSort, row) {
      // 在这里调用接口或执行其他方法来更新数据库中对应记录的排序字段
      row.id = id
      row.sort = newSort
      this.$set(row, 'id', id)
      this.$set(row, 'sort', newSort)
       Api.saveTrendsRule(this.selfAreaId, row).then((res) => {
         if (res.code !== 200) {
           this.$message.warning(res.message + '上移下移功能异常')
         }
      })
    },
    onShowDialog(type) {
      Api.getTrendsRule({ selfAreaId: this.selfAreaId, type: type }).then(res => {
        const max = Math.max(...res.data.map(item => item.sort))
        this.$set(this.form2, 'sort', (max + 1)) // 创建考核内容时，同时设置排序编号
      })
      this.$set(this, 'form2', {
        id: 0,
        type: type,
        areaId: this.selfAreaId
      })
      this.$refs['w-dialog'].onShowDialog()
    },
    showConfirm(textTitle, text, successFn, failFn) {
      this.$confirm(text, textTitle, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          successFn && successFn.call(this)
        })
        .catch(() => {
          failFn && failFn.call(this)
        })
    },
    onEditCancel() {
      this.showConfirm('温馨提示', '你是否确定取消本次修改？', () => {
        this.handleCloseEdit()
      })
    },
    onEditSure() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log(valid)
          this.form.areaId = this.selfAreaId
          Api.saveFixedRule(this.selfAreaId, this.form).then((data) => {
            this.$message.success('保存成功')
            this.$refs.ruleForm.clearValidate()
            this.getFixedRule()
          })
        } else {
          return false
        }
      })
    },
    handleFormRole() {
      const vm = this
      vm.loading = true
      const data = this.form
      const params = {
        selfAreaId: this.selfAreaId
      }
      if (this.type === 'edit') {
        data.brandId = this.detail.brandId
      }
      Api.createEnterprise(data, params)
        .then((res) => {
          if (res.code === 200) {
            vm.$message.success(
              `企业${this.type === 'edit' ? '编辑' : '添加'}成功！`
            )
            vm.initData()
            vm.handleCloseEdit()
          } else {
            vm.$message.warning(res.message)
          }
          vm.loading = false
        })
        .catch(() => {
          vm.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.system-setting {
  height: calc(100% - 48px);
  overflow: auto;
}
.breadcrumb-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f5;
  padding: 16px 30px 0 16px;
}

.breadcrumb {
  background-color: #f0f2f5;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.45);

  .last {
    color: rgba(0, 0, 0, 0.85);
  }

  span {
    cursor: pointer;
  }
}

/deep/.el-card__header {
  font-size: 14px;
  display: flex;
  > span {
    line-height: 32px;
    & + p {
      text-align: right;
      flex: 1;
    }
  }
}

.border {
  border-bottom: 1px dashed #d9d9d9;
}

.addbtn {
  display: inline-block;
  font-size: 14px;
  color: #1f8ffb;
  cursor: pointer;
  margin-bottom: 16px;
}
/deep/ .el-icon-top {
    font-size: 20px;
    margin: 3px;
    color: #409EFF;
  }
/deep/ .el-icon-top:hover {
    color: #020a3b;
    font-weight: 600;
    cursor: pointer;
  }
/deep/ .el-icon-bottom {
    font-size: 20px;
    color: #409EFF;
}
/deep/ .el-icon-bottom:hover {
    color: #020a3b;
    font-weight: 600;
    cursor: pointer;
}
</style>
